import { urlManger } from "@/url/common";
import { EntityUrl } from "@intasect/platform-core";
export const url_loginLog: EntityUrl = {
    get page() {
        return `${urlManger.getServiceUrl("log")}/log/login/page`;
    },
};
